import React, { useEffect, createElement } from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { ComparisonTable } from './components/ComparisonTable';
import { TomiSection } from './components/TomiSection';
import { BonusSection } from './components/BonusSection';
import { PricingCard } from './components/PricingCard';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { useScreenInit } from './useScreenInit';
export function App() {
  useScreenInit();
  useEffect(() => {
    // Initialize Meta Pixel
    const initPixel = () => {
      const f = window as any;
      if (f.fbq) return;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      f.fbq('init', '943022892065433');
      f.fbq('track', 'PageView');
    };
    initPixel();
  }, []);
  return <div className="min-h-screen bg-brand-cream text-brand-text-main overflow-x-hidden" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <div className="max-w-2xl mx-auto" data-id="element-3">
        <PainSection data-id="element-4" />
        <ComparisonTable data-id="element-5" />
        <TomiSection data-id="element-6" />
      </div>
      <BonusSection data-id="element-7" />
      <div className="max-w-2xl mx-auto" data-id="element-8">
        <PricingCard data-id="element-9" />
        <Guarantee data-id="element-10" />
      </div>
      <Testimonials data-id="element-11" />
      <div className="max-w-2xl mx-auto" data-id="element-12">
        <FAQ data-id="element-13" />
      </div>
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
      <SocialProofPopup data-id="element-16" />

      {/* Meta Pixel Noscript Fallback */}
      <noscript data-id="element-17">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=943022892065433&ev=PageView&noscript=1" alt="" data-id="element-18" />
      </noscript>
    </div>;
}